import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

import { LocalizationContext } from '../../../../AppContext';
import localization from './PrintersParlette.local';

export default function PrintersParlette({
  printers,
  onClickCreate,
  onClick,
}) {
  const local = localization[useContext(LocalizationContext)];

  return (
    <Container sx={{ pt: 5 }}>
      <Typography variant="h1" sx={{ mb: 2 }}>{local.title}</Typography>
      <Grid container spacing={2}>
        {printers && printers.map((item) => (
          <Grid key={item.id} item xs={6} md={4} lg={3}>
            <Card sx={{ width: 1, minHeight: 100 }} onClick={() => onClick(item.id)}>
              <CardActionArea sx={{ width: 1, minHeight: 100 }}>
                <CardContent>
                  <Chip
                    size="small"
                    sx={{ position: 'absolute', top: 5, right: 5 }}
                    label={item.active ? local.active : local.inactive}
                    color={item.active ? 'success' : 'secondary'}
                  />
                  <Typography variant="h6" sx={{ pt: 2 }}>{item.name}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
        <Grid item xs={6} md={4} lg={3}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={onClickCreate}
            sx={{ height: 100 }}
          >
            {local.create}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}

PrintersParlette.propTypes = {
  printers: PropTypes.arrayOf(PropTypes.shape({})),
  onClickCreate: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

PrintersParlette.defaultProps = {
  printers: undefined,
};
